<template>
  <div class="box box-blue">
    <div class="grid row">
      <h2 class="desktop-only">{{ title }}</h2>
      <div class="css-grid">
        <div v-for="top in $store.state.pageFrontpageEnergi" :key="top.id" class="grid-group">
          <h3>{{ top.top }}</h3>

          <section :key="top.top">
            <div v-for="(item) in top.data" :key="item.id" class="accordion-inner-wrapper">
              <button
                class="reset-btn accordion-inner-link"
                @click="$store.commit('setModal', item)"
              >
                <span>{{ item.title }}</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppFrontAccordion",
  props: {
    title: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      activeEl: false
    };
  }
};
</script>
<style lang="scss" scoped>
.box-blue {
  background: var(--blue-color);
  width: 100%;
  border: var(--spacing-md-3) solid #ffffff;
  border-top: 0px;
  box-sizing: border-box;
  color: #ffffff;
  padding: var(--spacing-md-2) 0px;

  .css-grid {
    margin-top: var(--spacing-md-3);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 20px;
    &-group {
      margin-bottom: 20px;
      &-item {
        margin-bottom: 20px;
      }
      &-link {
        margin-bottom: 5px;
      }
    }

    & .accordion-inner-link {
      position: relative;
      font-size: var(--font-h5);
      margin-bottom: 1rem;
      & span::after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: 8px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_796:1087)'%3E%3Cpath d='M9.00004 16.0711C4.74638 16.0711 1.28577 12.6105 1.28577 8.35685C1.28577 4.1032 4.74638 0.642578 9.00004 0.642578C13.2537 0.642578 16.7143 4.1032 16.7143 8.35685C16.7143 12.6105 13.2537 16.0711 9.00004 16.0711ZM9.00004 1.7069C7.6848 1.7069 6.39909 2.09691 5.30551 2.82762C4.21193 3.55832 3.35959 4.5969 2.85627 5.81203C2.35295 7.02715 2.22127 8.36424 2.47786 9.65421C2.73445 10.9442 3.36777 12.1291 4.29778 13.0591C5.2278 13.9891 6.41272 14.6225 7.70268 14.879C8.99265 15.1356 10.3297 15.0039 11.5449 14.5006C12.76 13.9973 13.7986 13.145 14.5293 12.0514C15.26 10.9578 15.65 9.67209 15.65 8.35685C15.648 6.59379 14.9467 4.90351 13.7001 3.65683C12.4534 2.41016 10.7631 1.7089 9.00004 1.7069V1.7069Z' fill='white'/%3E%3Cpath d='M7.25885 11.9122C7.18896 11.9122 7.11977 11.8984 7.05521 11.8717C6.99064 11.8449 6.93196 11.8057 6.88254 11.7563C6.83312 11.7069 6.79394 11.6483 6.76719 11.5837C6.74045 11.5191 6.72668 11.4499 6.72668 11.38V5.33391C6.72668 5.24065 6.75118 5.14902 6.79775 5.06821C6.84432 4.9874 6.91132 4.92025 6.99201 4.87348C7.07271 4.82672 7.16428 4.80199 7.25755 4.80176C7.35081 4.80153 7.4425 4.82582 7.52342 4.8722L12.8013 7.89657C12.8826 7.94317 12.9502 8.01042 12.9972 8.09151C13.0441 8.1726 13.0689 8.26467 13.0689 8.3584C13.0689 8.45212 13.0441 8.54418 12.9971 8.62526C12.9501 8.70633 12.8825 8.77355 12.8011 8.82011L7.52326 11.8418C7.44277 11.888 7.35161 11.9122 7.25885 11.9122V11.9122ZM7.79101 6.25221V10.4622L11.466 8.3581L7.79101 6.25221Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_796:1087'%3E%3Crect width='18' height='16.7143' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
      }
    }
  }
  & h3 {
    margin-bottom: 1rem;
  }
  & .accordion-link {
    margin-bottom: 1rem;
    text-align: left;

    &:hover {
      color: var(--link-active-color);
    }
    &:after {
      content: " +";
      color: var(--link-active-color);
    }
    &.is-active {
      &:after {
        content: " -";
        color: var(--link-active-color);
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .box-blue {
    border: 0px solid #ffffff;
    & .css-grid {
      margin-top: 0px;
    }
  }
  .desktop-only {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  .box-blue {
    padding: calc(var(--spacing-md-3) * 2) 0px;
    & .grid {
      padding: 0px var(--spacing-md-1);
      box-sizing: border-box;
    }
    & .css-grid {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }
}
</style>